<!-- ============================================================ -->
<!-- MAT LOGISTICS DASHBOARD - MAIN LAYOUT (HTML scaffold only)  -->
<!-- Generated: 12/15/2025                                     -->
<!-- Note: Pages live under src/app/pages; modals under modals  -->
<!-- ============================================================ -->

<!-- Logged-out landing: no shell, no auth guard, no loading wait -->
<ng-container *ngIf="isLoggedOutPage">
  <router-outlet></router-outlet>
</ng-container>

<ng-container *ngIf="!isLoggedOutPage">

<!-- Full-page loading overlay: shown until backend user info resolves -->
<div *ngIf="!userInfoLoaded" class="app-loading-overlay">
  <div class="app-loading-content">
    <div class="app-loading-logo">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" />
        <path d="M12 22V12" />
        <polyline points="3.29 7 12 12 20.71 7" />
        <path d="m7.5 4.27 9 5.15" />
      </svg>
    </div>
    <div class="app-loading-title">Mat Tracker</div>
    <div class="app-loading-spinner"></div>
    <div class="app-loading-text">Loading your workspace…</div>
  </div>
</div>

<div *ngIf="userInfoLoaded" class="app-container">

	<!-- ==================== TOP NAVIGATION ==================== -->
	<header class="top-nav">
		<div class="nav-content">
			<div class="nav-brand">
				<div class="brand-icon">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
						stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
						class="lucide lucide-package h-6 w-6 text-white">
						<path
							d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" />
						<path d="M12 22V12" />
						<polyline points="3.29 7 12 12 20.71 7" />
						<path d="m7.5 4.27 9 5.15" />
					</svg>
				</div>
				<div class="brand-text">
					<h1 class="brand-title">Mat Tracker</h1>
					<p class="brand-subtitle">Duke Energy Florida</p>
				</div>
			</div>

			<nav class="nav-menu">
				<a routerLink="/dashboard" routerLinkActive="active" class="nav-item">
					<svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
						fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
						stroke-linejoin="round">
						<path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" />
						<path
							d="M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
					</svg>
					<span>Dashboard</span>
				</a>
				<a routerLink="/create-request" routerLinkActive="active" class="nav-item">
					<svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
						fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
						stroke-linejoin="round">
						<path d="M5 12h14" />
						<path d="M12 5v14" />
					</svg>
					<span>New Request</span>
				</a>
				<a *ngIf="isMatCoordinator" routerLink="/map-view" routerLinkActive="active" class="nav-item">
					<svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
						fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
						stroke-linejoin="round">
						<path
							d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z" />
						<path d="M15 5.764v15" />
						<path d="M9 3.236v15" />
					</svg>
					<span>Map</span>
				</a>
				<a *ngIf="isMatCoordinator" routerLink="/future-view" routerLinkActive="active" class="nav-item">
					<svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
						fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
						stroke-linejoin="round">
						<path d="M16 7h6v6" />
						<path d="m22 7-8.5 8.5-5-5L2 17" />
					</svg>
					<span>Forecast</span>
				</a>
				<a *ngIf="isMatCoordinator" routerLink="/inventory" routerLinkActive="active" class="nav-item">
					<svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
						fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
						stroke-linejoin="round">
						<path
							d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" />
						<path d="M12 22V12" />
						<polyline points="3.29 7 12 12 20.71 7" />
						<path d="m7.5 4.27 9 5.15" />
					</svg>
					<span>Storage Hub</span>
				</a>
				<a *ngIf="isMatCoordinator" routerLink="/admin" routerLinkActive="active" class="nav-item">
					<svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
						fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
						stroke-linejoin="round">
						<path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path>
						<circle cx="12" cy="12" r="3"></circle>
					</svg>
					<span>Admin</span>
				</a>
			</nav>

			<div class="nav-actions">
				<div class="user-menu-container">
					<!-- User avatar button -->

						<button (click)="toggleUserMenu($event)" class="user-avatar-btn" type="button" [attr.aria-expanded]="showUserMenu">
						<ng-container *ngIf="userPhotoUrl">
							<img [src]="userPhotoUrl" alt="User avatar" class="user-avatar-img" />
						</ng-container>
						<ng-container *ngIf="!userPhotoUrl">
							<div class="user-avatar-circle">{{ userInitials }}</div>
						</ng-container>
						<span class="user-navbar-name" *ngIf="userName">
							<span class="user-navbar-name-text">{{ userName }}</span>
							<span *ngIf="userRoleInitials && userInfoLoaded" class="user-role-badge">{{ userRoleInitials }}</span>
						</span>
					</button>

					<!-- User dropdown card -->
					<div *ngIf="showUserMenu" class="user-dropdown-card" (click)="$event.stopPropagation()">
						<div class="user-card-content">
							<div class="user-card-avatar">
								<ng-container *ngIf="userPhotoUrl">
									<img [src]="userPhotoUrl" class="avatar-lg" alt="avatar" />
								</ng-container>
								<ng-container *ngIf="!userPhotoUrl">
									<div class="avatar-initials-lg">{{ userInitials }}</div>
								</ng-container>
							</div>
							<div class="user-card-info">
								<div class="user-display-name">{{ userName }}</div>
								<div class="user-display-email">{{ userEmail }}</div>
								<div class="user-display-role" *ngIf="userRole" style="font-size: 12px; color: #6b7280; margin-top: 2px; font-weight: 600;">
									{{ userRole }}
								</div>
							</div>
						</div>
						<div class="user-card-divider"></div>
						<div class="user-card-actions">
							<button class="btn-signout" (click)="logout()">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
									<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
									<polyline points="16 17 21 12 16 7"/>
									<line x1="21" y1="12" x2="9" y2="12"/>
								</svg>
								<span>Sign out</span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</header>

	<!-- ==================== MAIN CONTENT AREA ==================== -->
	<div class="main-content">

		<!-- ==================== PAGE CONTENT ==================== -->
		<div class="page-content">
			<!-- Router outlet to render page components -->
			<router-outlet></router-outlet>
		</div>
	</div>

	<!-- ==================== STICKY FOOTER ==================== -->
	<footer class="app-footer" role="contentinfo">
		<span>© 2026 Duke Energy Corporation. All rights reserved. | Mat Tracker v1.0</span>
	</footer>
</div>

</ng-container>

<!-- ==================== MODALS (to be wired later) ==================== -->
<!-- Modals will be moved to components under src/app/modals -->